import { store } from 'redux/store';
import { TUser } from 'redux/reducers/user/types';
import {
	TErrorCorrectionsErrorType,
	TErrorCorrectionsItem,
} from 'redux/reducers/errorCorrections/types';
import { DATES, DATES_ID } from 'services/constants/dates-constants';
import { ETableStructureAlign } from '../../../ui/EasTable/types';
import { ETableStructureType } from '../../../ui/EasTable/types';
// import { typeOfErrors } from './typeOfErrors';

export const errorsTableStructure = () => {
	const state = store.getState();
	return [
		{
			name: 'Type Of Error',
			selector: 'typeOfError',
			show: true,
			sortable: true,
			filterable: true,
			filter:
				state?.errorCorrections?.errorTypes?.map((errorType: TErrorCorrectionsErrorType) => [
					errorType.id,
					errorType.name,
				]) ?? [],

			// [
			// 	[typeOfErrors[0].id, typeOfErrors[0].name],
			// 	[typeOfErrors[1].id, typeOfErrors[1].name],
			// 	[typeOfErrors[2].id, typeOfErrors[2].name],
			// 	[typeOfErrors[3].id, typeOfErrors[3].name],
			// 	[typeOfErrors[4].id, typeOfErrors[4].name],
			// 	[typeOfErrors[5].id, typeOfErrors[5].name],
			// 	[typeOfErrors[6].id, typeOfErrors[6].name],
			// 	[typeOfErrors[7].id, typeOfErrors[7].name],
			// 	[typeOfErrors[8].id, typeOfErrors[8].name],
			// ],
			colSpan: 1,
			type: ETableStructureType.STATUS,
			align: ETableStructureAlign.LEFT,
		},

		{
			name: 'EM Name',
			selector: 'emName',
			show: false,
			sortable: true,
			filterable: false,
			filter: 'text',
			colSpan: 1,
			type: ETableStructureType.STRING,
			align: ETableStructureAlign.LEFT,
		},
		{
			name: 'EM Name',
			selector: 'emId',
			show: true,
			sortable: true,
			filterable: false,
			colSpan: 1,
			type: ETableStructureType.EM,
			align: ETableStructureAlign.LEFT,
			value: (item: TErrorCorrectionsItem) => {
				return {
					id: item.emId,
					name: item.emName,
				};
			},
		},
		{
			name: 'EAS Order ID',
			selector: 'easOrderId',
			show: true,
			sortable: true,
			filterable: false,
			filter: 'text',
			colSpan: 1,
			type: ETableStructureType.ORDER_ID,
			align: ETableStructureAlign.LEFT,
		},
		{
			name: 'External Order ID',
			selector: 'externalOrderId',
			show: true,
			sortable: true,
			filterable: false,
			filter: 'text',
			colSpan: 1,
			type: ETableStructureType.STRING,
			align: ETableStructureAlign.LEFT,
		},
		{
			name: 'Order Date',
			selector: 'orderDate',
			show: true,
			sortable: true,
			filterable: true,
			filter: [
				[DATES_ID.TODAY, DATES.TODAY],
				[DATES_ID.YESTERDAY, DATES.YESTERDAY],
				[DATES_ID.LAST_7_DAYS, DATES.LAST_7_DAYS],
				[DATES_ID.LAST_30_DAYS, DATES.LAST_30_DAYS],
				[DATES_ID.THIS_MONTH, DATES.THIS_MONTH],
				[DATES_ID.LAST_MONTH, DATES.LAST_MONTH],
				[DATES_ID.THIS_QUARTER, DATES.THIS_QUARTER],
				[DATES_ID.LAST_QUARTER, DATES.LAST_QUARTER],
				[DATES_ID.THIS_YEAR, DATES.THIS_YEAR],
				[DATES_ID.LAST_YEAR, DATES.LAST_YEAR],
			],
			colSpan: 1,
			type: ETableStructureType.DATE,
			align: ETableStructureAlign.LEFT,
		},
		{
			name: 'Delivery Country',
			selector: 'deliveryCountry',
			show: true,
			sortable: true,
			filterable: true,
			colSpan: 1,
			type: ETableStructureType.STRING,
			align: ETableStructureAlign.CENTER,
		},
		{
			name: 'Schemes',
			selector: 'schemes',
			show: true,
			sortable: true,
			filterable: true,
			filter: [
				['IOSS-NON-UNION', 'Non-Union OSS'],
				['IOSS-UNION', 'OSS'],
				['IOSS-IMPORT', 'IOSS'],
				['FC-', 'DDP/DDU Sales'],
				// ['FC-SIMPLE-REP', 'DDP/DDU Sales'],
				['B2B-INTRA-COMMUNAL', 'B2B'],
				['B2B-DOMESTIC', 'B2B Domestic'],
				['B2C-DOMESTIC', 'B2C Domestic'],
				['GIFTCARD_SCHEME', 'Gift Cards'],
				['NON_EU_IMPORT', 'NON EU Import'],
				['NON_EU_DOMESTIC', 'NON EU Domestic'],
				['N/A', 'N/A'],
			],
			colSpan: 1,
			type: ETableStructureType.STRING,
			align: ETableStructureAlign.LEFT,
		},
		{
			name: 'Status',
			selector: 'status',
			show: true,
			sortable: true,
			filterable: true,
			filter: [
				['New', 'New'],
				['Contacting client', 'Contacting client'],
				['Working on it', 'Working on it'],
				['Fixed', 'Fixed'],
				['Not Fixed', 'Not Fixed'],
			],
			colSpan: 1,
			type: ETableStructureType.STRING,
			align: ETableStructureAlign.LEFT,
		},
		{
			name: 'Corrector',
			selector: 'responsibleUser',
			show: true,
			sortable: true,
			filterable: true,
			filter: state?.user?.usersList?.map((user: TUser) => [user.id, user.fullName]) ?? [],
			// [
			// 	['Aleksandra', 'Aleksandra'],
			// 	['Aleksi', 'Aleksi'],
			// 	['Mikhail', 'Mikhail'],
			// 	['Nikolay', 'Nikolay'],
			// 	['Pёter', 'Pёter'],
			// 	['Robert', 'Robert'],
			// 	['Rostislav', 'Rostislav'],
			// 	['Teemu', 'Teemu'],
			// 	['Walde', 'Walde'],
			// ],
			colSpan: 1,
			type: ETableStructureType.USER,
			align: ETableStructureAlign.LEFT,
		},
	];
};
